document.addEventListener("fetch:cart-add", async function(event) {
    window.removeAndSyncWarranties();
})
document.addEventListener("fetch:cart-change", async function(event) {
    window.removeAndSyncWarranties();
})

  document.addEventListener('mulberry-shopify:loaded', async () => {
    window.removeAndSyncWarranties();
    await window.mulberryShop.cart.init();
    await mulberryShop.cart.render({refresh: true});
    function setupFetchListeners() {
      const { fetch: origFetch } = window;
      window.fetch = async (...args) => {
        const response = await origFetch(...args);
        let requestUrl = args[0];
        if (
          requestUrl.includes('cart/change') ||
          requestUrl.includes('cart/add') ||
          requestUrl.includes('cart/update')
        ) {
          response
            .clone()
            .json()
            .then(async (body) => {
              if (requestUrl.includes('cart/change')) {
                fetchChangeCustomEvent = new CustomEvent('fetch:cart-change');
                document.dispatchEvent(fetchChangeCustomEvent);
                console.log("fetch:cart-change")
              }
              if (requestUrl.includes('cart/add')) {
                fetchChangeCustomEvent = new CustomEvent('fetch:cart-add', {
                  detail: body,
                });
                document.dispatchEvent(fetchChangeCustomEvent);
                console.log("fetch:cart-add")

              }
              if (requestUrl.includes('cart.php') && !requestUrl.includes('cart/update')) {
                fetchCartCustomEvent = new CustomEvent('fetch:cart-page');
                document.dispatchEvent(fetchCartCustomEvent);
                console.log("fetch:cart-page")
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
        return response;
      };
    }
    setupFetchListeners();
});

$(() => {
  document.addEventListener('cart:refresh:end', async function(event) {
    await window.mulberryShop.cart.init();
    await mulberryShop.cart.render({refresh: true});
  });
});

  window.removeAndSyncWarranties = async () => {
    try {
      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
      });

      const cart = await cartResponse.json();
      const detachedWarrantyCart = await window.mulberryShop.removeDetachedWarranty(cart); // Remove Warranties First
      const syncedQuantitiesCart = await window.mulberryShop.cart.syncQuantities(
        detachedWarrantyCart
      ); // Sync Quantities Second
    //   await window.mulberryShop.cart.init();
      await mulberryShop.cart.render({refresh: true});
      // set cart total in class wcp-original-cart-total with format: $5,077
      const cartTotalElements = document.getElementsByClassName('wcp-original-cart-total');
      for (let i = 0; i < cartTotalElements.length; i++) {
        // there is no function in formatMoney to format the price like $5,077, so we will use toLocaleString
        cartTotalElements[i].textContent = (syncedQuantitiesCart.total_price / 100).toLocaleString(
          undefined,
          {
            style: 'currency',
            currency: syncedQuantitiesCart.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }
        );
      }
      if(syncedQuantitiesCart.item_count <= 0){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {detail: {cart: syncedQuantitiesCart}}));
      }
      const checkoutButtonPriceElements = document.getElementsByClassName('checkout-button__price');
      for (let i = 0; i < checkoutButtonPriceElements.length; i++) {
        checkoutButtonPriceElements[i].textContent = `${(
          syncedQuantitiesCart.total_price / 100
        ).toLocaleString(undefined, {
          style: 'currency',
          currency: syncedQuantitiesCart.currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} ${syncedQuantitiesCart.currency}`;
      }

    } catch (error) {
      console.error('Error in removeAndSyncWarranties:', error);
    }
  };
